export const GUEST_FEATURE_STATION_IDS = [1, 5];
